
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
se-wysiwyg{
  font-family:var(--ff-dmsans);
}

.panel{
  overflow:hidden;
  height:var(--fullHeight);
  display:none;
}

@media (prefers-reduced-motion: no-preference){

.panel{
    transition:height 0.5s ease-in-out
}
  }

.dropdown-trigger{
  display:flex;
  gap:1rem;
  align-items:center;
  font-family:var(--ff-dmsans);
  font-size:var(--fs-lg);
  color:var(--gray-600);
  margin:1rem 0;
  width:100%;
  background:none;
  border:none;
}

.dropdown-trigger hr{
    border:none;
    border-bottom:1px solid var(--gray-600);
    width:100%;
    margin-left:1rem;
  }

.dropdown-trigger:focus,
  .dropdown-trigger:hover{
    color:var(--brand-neutral-gray-900);
    cursor:pointer;
  }

.dropdown-trigger:focus hr, .dropdown-trigger:hover hr{
      border-bottom-color:var(---gray-900);
    }

.dropdown-trigger-label{
  flex-shrink:0;
}

blockquote{
  position:relative;
  display:block;
  margin-block-start:1rem;
  margin-block-end:1rem;
  margin-inline-start:2.5rem;
  margin-inline-end:2.5rem;
}

blockquote p{
    margin:0;
    padding-left:1.5rem;
  }

blockquote:before{
    position:absolute;
    content:'';
    display:flex;
    height:100%;
    width:3px;
    border-radius:2px;
    background:var(--brand-primary-2);
  }

p{
  font-family:var(--ff-dmsans);
  font-weight:var(--fw-medium);
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  color:var(--gray--800);
  margin-block-start:0em;
  margin-block-end:1rem;
  margin-inline-start:0px;
  margin-inline-end:0px;
}

@media (min-width: 768px){

p{
    font-size:var(--fs-base);
    line-height:var(--lh-base)
}
  }

@media (min-width: 1024px){

p{
    font-size:var(--fs-lg);
    line-height:var(--lh-lg)
}
  }

p.text-sm{
  font-size:var(--fs-sm);
}

.bold{
  font-weight:var(--fw-bold) !important;
}

.italic{
  font-style:italic;
}

a{
  font-family:var(--ff-dmsans);
  text-decoration:none;
  transition:0.3s;
  color:var(--brand-primary-2);
}

a:hover{
    text-decoration:underline !important;
    color:var(--brand-primary-1);
  }

a:focus{
    color:var(--brand-primary-1) !important;
  }

h1,
h2,
h3,
h4,
h5,
h6{
  margin:0 0 1rem 0 !important;
}

ul,
ol{
  margin-block-start:1em;
  margin-block-end:1em;
  margin-inline-start:1rem;
  margin-inline-end:0px;

  font-family:var(--ff-dmsans);
}

ul ul,
ol ol{
  margin-top:0;
  margin-bottom:0;
}

ul li,
ol li{
  margin-left:0.5rem;
  padding-left:0.5rem;
  font-family:var(--ff-dmsans);
  font-weight:var(--fw-medium);
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

@media (min-width: 768px){

ul li,
ol li{
    font-size:var(--fs-base);
    line-height:var(--lh-base)
}
  }

@media (min-width: 1024px){

ul li,
ol li{
    font-size:var(--fs-lg);
    line-height:var(--lh-lg)
}
  }

ol{
  list-style:decimal;
}

ol ol{
  list-style:lower-alpha;
}

ol ol ol{
  list-style:lower-greek;
}

ul{
  list-style-type:disc;
}

ul li::marker{
  color:var(--brand-primary-2);
  font-size:1em;
}

h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6{
  font-family:var(--ff-dmsans);
}

h1,
.h1{
  font-family:var(--ff-rift);
  font-size:var(--fs-h1-mobile);
  line-height:var(--lh-h1-mobile);
}

@media (min-width: 768px){

h1,
.h1{
    font-size:var(--fs-h1);
    line-height:var(--lh-h1);
}
  }

h2,
.h2{
  font-size:var(--fs-h2-mobile);
  line-height:var(--lh-h2-mobile);
}

@media (min-width: 768px){

h2,
.h2{
    font-size:var(--fs-h2);
    line-height:var(--lh-h2)
}
  }

h3,
.h3{
  font-size:var(--fs-h3-mobile);
  line-height:var(--lh-h3-mobile);
}

@media (min-width: 768px){

h3,
.h3{
    font-size:var(--fs-h3);
    line-height:var(--lh-h3)
}
  }

h4,
.h4{
  font-size:var(--fs-h4-mobile);
  line-height:var(--lh-h4-mobile);
}

@media (min-width: 768px){

h4,
.h4{
    font-size:var(--fs-h4);
    line-height:var(--lh-h4)
}
  }

h5,
.h5{
  font-size:var(--fs-h5-mobile);
  line-height:var(--lh-h5-mobile);
}

@media (min-width: 768px){

h5,
.h5{
    font-size:var(--fs-h5);
    line-height:var(--lh-h5)
}
  }

h6,
.h6{
  font-size:var(--fs-h6-mobile);
  line-height:var(--lh-h6-mobile);
}

@media (min-width: 768px){

h6,
.h6{
    font-size:var(--fs-h6);
    line-height:var(--lh-h6)
}
  }

.image{
  display:flex;
}

.image.align-left{
    display:block;
    float:left;
    align-self:start;
    margin-right:var(--spacing-4);
  }

.image.align-left figcaption{
      margin-right:var(--spacing-6);
    }

.image.align-right{
    display:block;
    float:right;
    align-self:end;
    margin-left:var(--spacing-6);
  }

.image.align-right figcaption{
      margin-left:var(--spacing-4);
    }

.image.align-center{
    display:flex;
    justify-content:center;
    margin:auto;
  }

.caption{
  display:table;
}

.caption > figcaption{
    display:table-caption;
    max-width:none;
    caption-side:bottom;
    font-size:var(--fs-sm-mobile);
    font-family:var(--ff-dmsans);
    line-height:var(--lh-sm-mobile);
  }

@media (min-width: 768px){

.caption > figcaption{
      font-size:var(--fs-sm);
      line-height:var(--lh-sm)
  }
    }

.caption > figcaption[contenteditable='true']:empty:before{
      content:attr(data-placeholder);
      font-style:italic;
    }

figure,
img{
  margin:0;
  max-width:100%;
}

figcaption{
  padding-top:0.5625rem;
  padding-bottom:0.5625rem;
  font-size:0.875rem;
  line-height:1.375rem;
}

[dir='ltr'] .align-right{
    margin-left:2.5rem;
  }

[dir='ltr'] .align-left{
    margin-right:2.5rem;
  }

.remote-video{
  max-width:100vw;
}

.remote-video iframe{
    max-width:100%;
    max-height:50vh;
  }

@media (min-width: 768px){

.remote-video iframe{
      max-height:none
  }
    }

.se-wysiwyg-table-wrapper{
  overflow-x:auto;
}

table{
  margin:0 auto 2rem;
  border-spacing:0;
  border:2px solid var(--brand-neutral-gray-400);
}

table caption{
    font-weight:var(--fw-bold);
    font-size:var(--fs-base);
    text-align:center;
    padding:0.5rem;
  }

table thead tr{
    border-bottom:1px solid #fff;
  }

table tr:nth-child(odd){
    background-color:#eee;
  }

table th{
    background-color:var(--brand-primary-2);
    color:#fff;
  }

table th,
  table td{
    padding:1rem;
    border:1px solid #fff;
    text-align:center;
  }

table th,
  table td,
  table th p,
  table td p{
    font-size:var(--fs-base);
    line-height:var(--lh-base);
  }

.se-pull-quote--wysiwyg a{
  color:var(--brand-neutral-white);
  text-decoration:underline;
}

.se-pull-quote--wysiwyg a:focus,
  .se-pull-quote--wysiwyg a:hover{
    color:var(--brand-neutral-white);
  }

.se-pull-quote--wysiwyg > p{
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  font-weight:var(--fw-medium);
  font-family:var(--ff-dmsans);
}

@media (min-width: 768px){

.se-pull-quote--wysiwyg > p{
    font-size:var(--fs-xl);
    line-height:var(--lh-xl)
}
  }
`;